const moment = require('moment');

/**
 * Valor por defecto para el objeto licencia
 * @returns {{modalidad_pago: null, precio: null, fecha_inicio: null, fecha_fin: null, cantidad_usuarios: null, usuarios_multiusuarios: null, observaciones: null, id_empresa: null, usuarios_contratistas: null}}
 */
export const filtros = () => {
  return {
    busqueda: '',
    page: 1,
    cantidad: 10
  };
};

/**
 * Valor por defecto para el objeto licencia
 * @returns {{modalidad_pago: null, precio: null, fecha_inicio: null, fecha_fin: null, cantidad_usuarios: null, usuarios_multiusuarios: null, observaciones: null, id_empresa: null, usuarios_contratistas: null}}
 */
export const licencia = () => {

  const inicio = moment().format('yyyy-MM-DD');
  const fin = moment().add(30, 'days').format('yyyy-MM-DD');

  return {
    id_empresa: null,
    cantidad_usuarios: 1,
    number_products: 0,
    fechas: [
      inicio,
      fin
    ],
    fecha_inicio: null,
    fecha_fin: null,
    usuarios_multiusuarios: 0,
    usuarios_contratistas: 0,
    modalidad_pago: null,
    precio: 0,
    valor_cargue: 0,
    observaciones: null,
    horas: 0,
    responsible_user_id: null
  };
};

export default {
  licencias: {
    data: []
  },
  licencia: licencia(),
  filtros: filtros(),
  accion: 'Crear',
  modalidades:[],
  modal: {
    ver: false
  },
  modalAcceptLicense: {
    isOpen: false
  },
  modalDetailsLicense: {
    isOpen: false
  },
  optionsMultiUser: [
    { text: 'Si', value: 1 },
    { text: 'No', value: 0 },
  ],
  paymentMethods: [],
  empresas: [],
  reporte: {
    empresas: [],
    solo_activos: false,
    solo_vigentes: false,
  },
  responsibles: [],
  tabActive: 'license-history',
  isVisibleDetailsLicensingContract: 'close'
};
